import { ReactNode, useEffect, useState } from "react"
import { UploadFile } from "../../common/Util";
import { ResponseParamBase } from "../../common/Types";
import { ApiUrl, RouterUrl } from "../../common/Params";
import { useNavigate } from "react-router-dom";
import { Login } from "../pages/Login";
import { CircularProgress } from "@mui/material";
import { use100vh } from "react-div-100vh";
import { LogoutResponseParam } from "../Config";

type AuthProviderProp = {
    childComponent: ReactNode,
}

type ResponseParam = ResponseParamBase & {

}

export const LoginProvider = (prop: AuthProviderProp) => {
    
    const height = use100vh();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [response, SetResponse] = useState<ResponseParam>({message: '', resultFlg: false});
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            await UploadFile<ResponseParam>(ApiUrl.IsLogin, {}, setIsLoading)
            .then(async (response) => {
                SetResponse((value) => {return response.data});
                if(!response.data.resultFlg){
                    await UploadFile<LogoutResponseParam>(
                        ApiUrl.Logout,
                        {
                            'refresh': localStorage.getItem('refreshtoken'),
                            'access': localStorage.getItem('accesstoken'),
                        },
                        null,
                    ).then((response) => {
                        localStorage.removeItem('accesstoken');
                        localStorage.removeItem('refreshtoken');
                        //window.location.reload();
                        //JumpPage(RouterUrl.Upload, null, navigate);
                    }).finally(() => {
                        
                    });
                }
            })
            .catch((e) => {
                SetResponse((value) => {return {message: '', resultFlg: false}})
                //navigate(RouterUrl.Login)
            })
        })()
    },[])

    return (
        <>
            {
                isLoading ?
                    <div style={{width: "100%", height: height ? height : '100vh', display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <CircularProgress></CircularProgress>
                    </div>
                    :
                    response?.resultFlg ?
                    prop.childComponent
                    :
                    <Login loginMessage={response.message}></Login>
            }
        </>
    )
}